export default {
  getOrderCancelReasons: '/courier/api/v2/order/cancel/check',
  abortOrder: '/gateway/capp/order/courierOrderService/abortOrder',
  queryCourierChance: '/v3/cancelOrder/queryCourierChance'
}
